import Macy from "macy";

var currentNav = null;
var menuBottom = null;
var currentMenuLink = null;
var navs = null;
var navCats = null;
var subs = null;
var currentSub = null;
var catGroup = null;
var subGroup = null;

function closeMenu() {
    menuBottom.classList.remove("active");
    navs.forEach(x => x.classList.remove("active"));
    navCats.forEach(x => x.parentNode.classList.remove("active"));
    subs.forEach(x => x.classList.remove("active"));
    // subGroup.style.maxHeight = `0px`;

    currentNav = null;
    currentMenuLink = null;
    currentSub = null;
}

function initMenu() {
    var menuLinks = Array.from(document.querySelectorAll(".nav-main__list__item--group a"));
    navs = Array.from(document.querySelectorAll(".nav-cat"));
    navCats = Array.from(document.querySelectorAll("#type-products .nav-cat__list__item__link"));
    subs = Array.from(document.querySelectorAll(".nav-sub"));
    menuBottom = document.getElementById("header-bottom-desktop");
    catGroup = document.querySelector('.nav-cat-group');
    subGroup = document.querySelector('.nav-sub-group');

    document.addEventListener("click", e => {
        var els = Array.from(document.elementsFromPoint(e.clientX, e.clientY));
        if (els.indexOf(menuBottom) == -1 && currentNav) {
            closeMenu();
        }
    });

    menuLinks.forEach(menuLink => {
        menuLink.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();
            currentMenuLink = menuLink;
            menuLinks.forEach(x => x.parentNode.classList.remove("active"));
            currentMenuLink.parentNode.classList.add("active");

            menuBottom.classList.add("active");
            currentNav = document.getElementById(currentMenuLink.getAttribute("href").substr(1));
            
            navs.forEach(x => x.classList.remove("active"));
            currentNav.classList.add("active");

            subs.forEach(x => x.classList.remove("active"));
            console.log("nav click");
        });
    });

    navCats.forEach(navCat => {
        navCat.addEventListener("click", e => {
            e.preventDefault();
            e.stopPropagation();

            currentSub = document.querySelector(`#${navCat.getAttribute("data-menu")}`);

            // Add active state to correct category (for active styling on link)
            navCats.forEach(x => x.parentNode.classList.remove("active"));
            navCat.parentNode.classList.add("active");

            // Add active state to correct subcategory
            subs.forEach(x => x.classList.remove("active"));

            if (currentSub) {
                currentSub.classList.add("active");
                console.log(subGroup);
                subGroup.style.maxHeight = `${currentSub.scrollHeight}px`;
                var macyInstance = Macy({
                    container: currentSub.querySelector(".container--nav-sub .nav-sub__blocks")
                });
            } else {
                
                subGroup.style.maxHeight = `0px`;
            }
        });
    });
}

export default function() {
    //    initSubcategoryMasonry();
    initMenu();
}
